import type { ReactNode } from 'react';
import './FilterSection.css';

interface FilterSectionProps {
  expanded: boolean;
  onToggleExpanded: () => void;
  hasActiveFilters: boolean;
  onClearFilters: () => void;
  clearLabel?: string;
  headerRight?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function FilterSection({
  expanded,
  onToggleExpanded,
  hasActiveFilters,
  onClearFilters,
  clearLabel = 'リセット',
  headerRight,
  children,
  className,
}: FilterSectionProps) {
  return (
    <div className={`filter-section${className ? ` ${className}` : ''}`}>
      <div className={`filter-header${hasActiveFilters ? ' filter-active' : ''}${expanded ? ' filter-expanded' : ''}`}>
        <div className="filter-header-left">
          <button
            type="button"
            className="filter-toggle"
            onClick={onToggleExpanded}
          >
            <span className="filter-icon">{expanded ? '▼' : '▶'}</span>
            <span className="filter-label">フィルタ</span>
            {hasActiveFilters && <span className="filter-active-dot" />}
          </button>
          {hasActiveFilters && (
            <button
              type="button"
              className="clear-filters-link"
              onClick={onClearFilters}
            >
              {clearLabel}
            </button>
          )}
        </div>
        <div className="filter-header-right">
          {headerRight}
        </div>
      </div>
      {expanded && (
        <div className="filter-controls">
          <button
            type="button"
            className="filter-close-button"
            onClick={onToggleExpanded}
            aria-label="フィルタを閉じる"
          >
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" style={{ display: 'block' }}><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg>
          </button>
          {children}
        </div>
      )}
    </div>
  );
}
